// 4. Composant pour les constantes vitales
// components/consultation/summary/VitalSignsCard.tsx
import React from 'react';
import { InfoCard } from './InfoCard';

interface VitalSignsCardProps {
  poids: string;
  taille: string;
  tensionArterielle: string;
  rythmeCardiaque: string;
  temperature: string;
}

export const VitalSignsCard: React.FC<VitalSignsCardProps> = ({
  poids,
  taille,
  tensionArterielle,
  rythmeCardiaque,
  temperature,
}) => {
  return (
    <InfoCard
      title="Constantes"
      icon="💉"
      iconColor="text-green-500"
      borderColor="border-green-100"
    >
      <div className="text-gray-700 text-sm space-y-1">
        <div><b>Poids :</b> {poids} kg</div>
        <div><b>Taille :</b> {taille} cm</div>
        <div><b>Tension artérielle :</b> {tensionArterielle}</div>
        <div><b>Rythme cardiaque :</b> {rythmeCardiaque}</div>
        <div><b>Température :</b> {temperature} °C</div>
      </div>
    </InfoCard>
  );
};
